export const ka = {
  title: 'ტროპიკული ხის საფარი',
  subtitle: '2020, 10 m/0.5 ha, tropical, WRI',
  download_data: 'https://data.globalforestwatch.org/datasets/tropical-tree-cover/explore',
  learn_more: '',
  content: [
    {
      label: 'ფუნქცია',
      value:
        'აჩვენებს ხის ზომას ათი მეტრის მასშტაბით და ხის საფარი ნახევარი ჰექტარის მასშტაბით, რათა შესაძლებელი გახდეს ხეების ზუსტი მონიტორინგი ურბანულ ადგილებში, სასოფლო-სამეურნეო მიწებზე და ღია ტილოებსა და მშრალ ტყის ეკოსისტემებში',
    },
    {
      label: 'რეზოლუცია',
      value: '10 x 10 მეტრი, ნახევარი ჰექტარი',
    },
    {
      label: 'გეოგრაფიული გაშუქება',
      value: '4.3 მილიარდი ჰექტარი ტროპიკები (-23.44-დან 23.44 გრძედი)',
    },
    {
      label: 'წყარო',
      value: 'World Resources Institute',
    },
    {
      label: 'სიხშირე',
      value: '2017 წლიდან ყოველწლიურად ცვლილებების გამოვლენის რუკები დაგეგმილია 2024 წლის გამოშვებისთვის.',
    },
    {
      label: 'შინაარსის თარიღი',
      value: '2020',
    },
    {
      label: 'გაფრთხილება',
      value:
        'ეს მონაცემთა ბაზა იყენებს ხის განსხვავებულ განმარტებას და ხის საფარის განსხვავებულ განმარტებას, ვიდრე ჰანსენი და სხვები (2013). ეს მონაცემთა ბაზა განსაზღვრავს ხეს როგორც სიმაღლის, ასევე გვირგვინის დიამეტრის მიხედვით. ხის მცენარეულობა აღემატება 5 მეტრს, მიუხედავად გვირგვინის დიამეტრისა, ან 3-დან 5 მეტრამდე მინიმალური გვირგვინის დიამეტრით 5 მეტრი ითვლება ხე. ეს განმარტება განსხვავდება Hansen et al. (2013), რომელიც განსაზღვრავს ხეს, როგორც ნებისმიერ მცენარეულობას მინიმუმ 5 მეტრის სიმაღლეზე. ტროპიკული ხის საფარის მონაცემთა ბაზა არ იშლება პლანტაციის ხეები არა პლანტაციის ხეებიდან.\n\n0.5 ჰა-ზე ნაკლები ფორმის ფორმის ანალიზები ან სტატისტიკა შეიძლება არ იყოს ზუსტი.',
    },
    {
      label: 'ლიცენზია',
      value: 'CC 4.0',
    },
  ],
  overview: {
    label: 'მიმოხილვა',
    value:
      'ტროპიკული ხე მოიცავს მონაცემთა რუკებს, რომლებიც ათი მეტრის მასშტაბით და ხის საფარით ნახევარი ჰექტარის მასშტაბით, რათა შესაძლებელი გახდეს ხეების ზუსტი მონიტორინგი ურბანულ ადგილებში, სასოფლო-სამეურნეო მიწებზე და ღია ტილოებსა და მშრალ ტყის ეკოსისტემებში. მონაცემები ვრცელდება 4.3 მილიარდ ჰექტარზე მეტი გლობალური ტროპიკებით.\n\nმონაცემები გამომდინარეობს მრავალ დროებითი კონვოლუციური ნერვული ქსელის მოდელებიდან, რომლებიც გამოიყენება Sentinel ოპტიკური და რადარის გამოსახულებებზე. 10 მეტრიანი მონაცემთა ბაზა არის ორობითი ხის ზომის ფენა, რომელიც მსგავსია მიწის საფარის რუკის მსგავსი, ხოლო ხის საფარის მონაცემები წარმოადგენს ფრაქციულ საფარს ნახევრად ჰექტარის მასშტაბით. დამატებითი ინფორმაცია მეთოდოლოგიისა და ანალიზის შესახებ შეგიძლიათ იხილოთ GitHub გვერდზე.',
  },
  citation: {
    label: 'ციტატა',
    value:
      'Use the following credit when this data is displayed: Source: 14/02/2025, accessed through Global Forest Watch on 14/02/2025\n\nUse the following credit when this data is cited: Brandt,\nBrandt, J., Ertel, J., Spore, J., & Stolle, F. (2023). WALL-to-wall\nmapping of tree extent in the tropics with sentinel-1 and sentinel-2. Remote Sensing of Environment, 292, 113574. https://doi.org/10.1016/j.rse.2023.11357',
  },
};
